// Store data in LS
export function storeInLS(key, data) {
  localStorage.setItem(key, data);
}

// Read from LS
export function readFromLS(key) {
  return localStorage.getItem(key);
}

// Delete from LS
export function deleteFromLS(key) {
  return localStorage.removeItem(key);
}

// Operations for logging out the user
export function logout() {
  localStorage.removeItem(process.env.REACT_APP_LS_LOGIN_TOKEN);
  window.location.href = "/login";
}

// Formatea una fecha YYYY-MM-DD
export function formatFecha(fecha) {
  if (fecha) {
    let fechaFormat = new Date(fecha);
    const fechaProcesada = new Date(
      fechaFormat.getTime() + fechaFormat.getTimezoneOffset() * 60 * 1000
    );
    return `${fechaProcesada.getFullYear()}-${(
      "0" +
      (fechaProcesada.getMonth() + 1)
    ).slice(-2)}-${("0" + fechaProcesada.getDate()).slice(-2)}`;
  }
}

// Vencimiento del proceso: usa la fecha almacenada (fechavencimiento) si existe;
// si no (procesos previos al backfill), la calcula como fechacreacion + 1 año,
// igual que se venía haciendo. Devuelve un objeto Date o null.
export function vencimientoDeProceso(proceso) {
  if (!proceso) return null;
  if (proceso.fechavencimiento) return new Date(proceso.fechavencimiento);
  if (!proceso.fechacreacion) return null;
  const v = new Date(proceso.fechacreacion);
  v.setFullYear(v.getFullYear() + 1);
  return v;
}

// true si el proceso ya venció (su fecha de vencimiento es anterior a hoy).
export function estaVencido(proceso) {
  const v = vencimientoDeProceso(proceso);
  return v ? v < new Date() : false;
}

// Convierte un epoch a fecha DD/MM/YYYY
export function epochAFecha(epoch) {
  var date = new Date(epoch * 1000);
  const dia = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  const mes = date.getMonth() < 10 ? "0" + date.getMonth() : date.getMonth();
  const año = date.getFullYear();
  return `${dia}/${mes}/${año}`;
}

// Access API
// With timeout specified in .env
export function accessAPI(
  verb,
  endpoint,
  data,
  callbackSuccess,
  callbackFail,
  file
) {
  const url = process.env.REACT_APP_API_URL + "/" + endpoint;
  const accessToken = readFromLS(process.env.REACT_APP_LS_LOGIN_TOKEN);

  let fetchConfig = {
    method: verb,
    headers: {
      Authorization: "Bearer " + accessToken,
    },
  };

  let dataParaEnviar;

  // Si hay un archivo para enviar, genera el form data
  if (file) {
    let formData = new FormData();
    formData.append("archivo", file);
    if (data) {
      let datosArray = Object.entries(data);
      for (const [key, value] of datosArray) {
        formData.append(key, value);
      }
    }
    dataParaEnviar = formData;
  } else if (data) {
    fetchConfig.headers["Content-Type"] = "application/json";
    fetchConfig.headers["accept-encoding"] = "gzip, deflate";
    dataParaEnviar = JSON.stringify(data);
  }
  fetchConfig.body = dataParaEnviar;

  Promise.race([
    fetch(url, fetchConfig),
    new Promise(function (resolve, reject) {
      setTimeout(
        () => reject(new Error("request timeout")),
        process.env.REACT_APP_API_TIMEOUT
      );
    }),
  ])
    .then((response) => {
      if (response.status === 204) {
        callbackSuccess();
      } else if (response.status >= 200 && response.status < 300) {
        response.json().then((data) => {
          callbackSuccess(data);
        });
      } else {
        response.json().then((data) => {
          data.status = response.status;
          APIerror(data);
          callbackFail(data);
        });
      }
    })
    .catch((e) => {
      var response = {
        status: 500,
        msg: "Error de servidor.",
      };
      callbackFail(response);
    });
}

// Descargar archivo
export function downloadFile(
  endpoint,
  filename,
  callbackSuccess,
  callbackFail
) {
  const url = process.env.REACT_APP_API_URL + "/" + endpoint;
  const accessToken = readFromLS(process.env.REACT_APP_LS_LOGIN_TOKEN);
  var fetchConfig = {
    method: "GET",
    headers: {
      "accept-encoding": "gzip, deflate",
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
  };
  Promise.race([
    fetch(url, fetchConfig),
    new Promise(function (resolve, reject) {
      setTimeout(
        () => reject(new Error("request timeout")),
        process.env.REACT_APP_API_TIMEOUT
      );
    }),
  ])
    .then((response) => {
      if (response.status === 204) {
        callbackSuccess();
      } else if (response.status >= 200 && response.status < 300) {
        response.blob().then((data) => {
          const blobUrl = URL.createObjectURL(data);
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = filename;
          document.body.appendChild(link);
          link.dispatchEvent(
            new MouseEvent("click", {
              bubbles: true,
              cancelable: true,
              view: window,
            })
          );
          document.body.removeChild(link);
          callbackSuccess(data);
        });
      } else {
        response.json().then((data) => {
          data.status = response.status;
          callbackFail(data);
        });
      }
    })
    .catch((e) => {
      var response = {
        status: 500,
        msg: "Error de servidor.",
      };
      callbackFail(response);
    });
}

// Manejo centralizado de errores de API
export function APIerror(response) {
  if (response.status >= 500) {
    return;
  }

  if (response.status === 401 || response.status === 403) {
    deleteFromLS(process.env.REACT_APP_LS_LOGIN_TOKEN);
    window.location.href = "/login";
    return;
  }

  return;
}
